import { render, staticRenderFns } from "./AscAnserSignatureTemplate.vue?vue&type=template&id=7bdbaf24&"
import script from "./AscAnserSignatureTemplate.vue?vue&type=script&lang=js&"
export * from "./AscAnserSignatureTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports